import { render } from "./DynamicPageList.vue?vue&type=template&id=41c16214&scoped=true"
import script from "./DynamicPageList.vue?vue&type=script&lang=js"
export * from "./DynamicPageList.vue?vue&type=script&lang=js"

import "./DynamicPageList.vue?vue&type=style&index=0&id=41c16214&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c16214"]])

export default __exports__